// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListItem--default {
  list-style: none;
  margin: 0;
  padding: 5px 15px;
}
.ListItem--flex {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
}
.ListItem__icon {
  padding-right: 10px;
}
.ListItem__text {
  flex-grow: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/List/ListItem.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,SAAA;EACA,iBAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AADR;AAII;EACI,mBAAA;AAFR;AAKI;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHR","sourcesContent":[".ListItem {\n    &--default {\n        list-style: none;\n        margin: 0;\n        padding: 5px 15px;\n    }\n\n    &--flex {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        align-items: center;\n        align-content: center;\n    }\n\n    &__icon {\n        padding-right: 10px;\n    }\n\n    &__text {\n        flex-grow: 2;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
